module.exports = __webpack_public_path__ + "static/media/activate-key-porter.ec4c8c3e.svg";